import { PostActionButtonType } from '~/post/types';
import { PostAction, UncheckedPostAction, ValidPostAction } from './types';

export type usePostActionsResponse = {
  singleActions: PostAction[];
  stackedActions: PostAction[];
};

export const isValidPostAction = (
  action: UncheckedPostAction
): action is ValidPostAction => {
  return action.condition && !!action.callback;
};

// Reduce post actions into single and stacked actions
export const reducePostActionsByType = (
  result: usePostActionsResponse,
  action: ValidPostAction
): usePostActionsResponse => {
  // Remove the condition property as all false conditions
  // will have been filtered out
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { condition, ...newAction } = action;
  if (action.type === PostActionButtonType.SINGLE)
    return {
      ...result,
      singleActions: [...result.singleActions, newAction],
    };
  if (action.type === PostActionButtonType.STACKED)
    return {
      ...result,
      stackedActions: [...result.stackedActions, newAction],
    };
  return result;
};
